// src/utils/api.js
import axios from 'axios';

export const BASE_URL = 'https://myworkplace.in/vms/vms_client_api';

const toUrl = (p) =>
  `${BASE_URL.replace(/\/+$/, '')}/${String(p).replace(/^\/+/, '')}`;

export const api = axios.create({ baseURL: BASE_URL });


// ---------------- Endpoints ----------------
export const LOGIN_END_POINT                 = toUrl('login/login.php');

export const DEPARTMENT_LIST_API             = toUrl('departments/list.php');
export const DEPARTMENT_ADD_API              = toUrl('departments/add.php');
export const DEPARTMENT_UPDATE_API           = toUrl('departments/update.php');
export const DEPARTMENT_DELETE_API           = toUrl('departments/delete.php');

export const CLIENT_USER_ADD_API             = toUrl('client_user_management/add.php');
export const CLIENT_ROLES_LIST_API           = toUrl('client_user_management/rolls.php');
export const CLIENT_USERS_LIST_API           = toUrl('client_user_management/list.php');
export const CLIENT_USERS_UPDATE_API         = toUrl('client_user_management/update.php');

export const SECURITY_MATERIAL_LIST_API      = toUrl('security_material/list.php');
export const SECURITY_MATERIAL_ADD_API       = toUrl('security_material/add.php');
export const SECURITY_MATERIAL_TOGGLE_STATUS_API = toUrl('security_material/toggle_status.php');

export const VISITOR_ENTRY_SAVE_API          = toUrl('visitor_entry/save.php');
export const VISITOR_REPORT_API              = toUrl('visitor_entry/list.php');

export const VISITOR_TYPES_LIST_API          = toUrl('visitor_types/list.php');
export const VISITOR_TYPES_ADD_API           = toUrl('visitor_types/add.php');
export const VISITOR_TYPES_TOGGLE_API        = toUrl('visitor_types/toggle_status.php');

export const VISIT_PURPOSE_LIST_API          = toUrl('visit_purposes/list.php');
export const VISIT_PURPOSE_ADD_API           = toUrl('visit_purposes/add.php');
export const VISIT_PURPOSE_TOGGLE_API        = toUrl('visit_purposes/toggle_status.php');

export const MARK_REQUEST_SENT_API           = toUrl('visitor_entry/request_gatepass.php');
export const PENDING_VISITOR_LIST_API        = toUrl('visitor_entry/pending_visitors.php');

export const GET_VISITOR_BY_ID_API           = toUrl('visitor_entry/get_visitor_by_id.php');
export const UPDATE_VISITOR_APPROVAL_API     = toUrl('visitor_entry/update_visitor_approval.php');

export const DASHBOARD_STATUS_ENDPOINT       = toUrl('dashboard/dashboard_stats.php');

export const WABA_SETTINGS_API               = toUrl('settings/waba_settings.php');
export const EMAIL_SETTINGS_API              = toUrl('settings/email_settings.php');

export const SEND_OTP_API                    = toUrl('visitor_entry/otp_send.php');
export const VERIFY_OTP_API                  = toUrl('visitor_entry/otp_varify.php');

export const COMPANY_SUGGESTIONS_API         = toUrl('company/company_suggestions.php');
export const FACE_SEARCH_ENDPOINT            = toUrl('visitor_entry/search_by_photo.php');
export const GET_VISITOR_HISTORY_API         = toUrl('visitor_entry/get_visitor_history.php');

export const VISITOR_OUT_LIST_API            = toUrl('visitor_out/list.php');
export const VISITOR_OUT_UPDATE_API          = toUrl('visitor_out/update.php');

export const GET_FILTERS_DATA_API            = toUrl('reports/get_filters_data.php');
export const VISITOR_REPORT_SEARCH_API       = toUrl('reports/visitor_report_search.php');
